import React from "react";
import { Form } from "antd";
import AlphabetInput from "../AlphabetInput"; // adjust path if needed

const FormItemAlphabetInput = ({
  label,
  name,
  rules = [],
  placeholder = "Enter value",
  maxLength,
  disabled = false,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
        <AlphabetInput placeholder={placeholder} maxLength={maxLength} disabled={disabled} />
     
    </Form.Item>
  );
};

export default FormItemAlphabetInput;